import { useSelector } from 'react-redux'
import { shows as fixtures } from '@fedsim/imports'
import { getModeledShows as getStoreItems, sortByRepeatIndex } from 'selectors'

import { mapImported } from '../helpers'
import Form from './form'

interface useShowsInterface {
  mapped: any[];
  fixtures: any[];
  imported: any[];
  notImported: any[];
  Form: any;
}

export const useShows = (): useShowsInterface => {
  const imported: any[] = useSelector(getStoreItems)
  const sorted = imported?.sort(sortByRepeatIndex)
  const mapped = mapImported(fixtures, sorted)
  const notImported = mapped
    .filter(item => item.imported === false)
    .sort(sortByRepeatIndex)

  return { mapped, fixtures, imported, notImported, Form }
}
